import LazyLoad from "@components/LazyLoad";
import React, { ReactNode, isValidElement } from "react";

import { useCurrentSettings } from "../PersistedData/settingsSlice";

export interface AccessibilityProps {
  full?: ReactNode;
  basic?: ReactNode;
  noscript: ReactNode;
}

export interface UseAccessibilityProps {
  full?: any;
  basic?: any;
  noscript: any;
}

const loadAndShow = (content) => {
  if (isValidElement(content)) {
    return content;
  }
  const [load, props] = content;
  return <LazyLoad load={load} {...props} />;
};

export const useAccessibility = ({ full, basic, noscript }: UseAccessibilityProps) => {
  const settings = useCurrentSettings();

  if (full && settings.mode === "full") {
    return loadAndShow(full);
  }
  if (basic && settings.mode === "basic") {
    return loadAndShow(basic);
  }
  // Retourné directement la version noscript lazy load non supporté pour noscript
  return loadAndShow(noscript);
};
